import styled from 'styled-components';

export const Nutrient = styled.div`
  display: flex;
  justify-content: space-between;
`;
